
export default function constants (state = {}, action) {
    switch (action.type) {
        case 'SET_CONSTANTS':
            return action.constants;
        default:
            return state;
    }
};